import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { contentLibraryFileUnshareRequested } from 'features/content-library/actions';

export function* unshareContentLibraryFileSaga(
  action: ReturnType<typeof contentLibraryFileUnshareRequested>
) {
  yield call(SignalingSocket.send, {
    event: 'unshareLibraryFile',
    data: { id: action.payload.id },
  });
}
